export default __webpack_public_path__ + "static/media/secret_pay_offline.7e28d6f0.svg";